import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';
import {OktaAuthService} from '@okta/okta-angular';
import {UtilService} from "./services/util.service";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterViewInit {
  isAuthenticated: boolean;
  leftMenu: boolean = true;
  title = "Broker Hub"
  initialLoading = true;

  constructor(public oktaAuth: OktaAuthService, public router: Router, private utilService: UtilService, private http: HttpClient) {
    // Subscribe to authentication state changes

  }

  async ngOnInit() {
    let self = this;
    this.oktaAuth.$authenticationState.subscribe(
      async (isAuthenticated: boolean) => {
        this.isAuthenticated = isAuthenticated;
        await this.oktaAuth.getUser().then(data => {
          this.utilService.setUserType(data.userType);
        });
      }
    );


  }

  ngAfterViewInit() {
    this.initialLoading = false;
  }

  login() {
    this.oktaAuth.signInWithRedirect({
      originalUri: '/dashboard'
    })
  }


}
